var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from 'react';
import styled, { css } from 'styled-components';
import { getSpacingSelector } from '@signal/theme/selectors';
var commonStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: ", "px;\n"])), function (_ref) {
  var marginTop = _ref.marginTop;
  return marginTop ? getSpacingSelector(4) : 0;
});
var Wrapper = styled.section(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n"])), commonStyles, function (_ref2) {
  var direction = _ref2.direction;
  return direction;
}, function (_ref3) {
  var align = _ref3.align;
  return align;
}, function (_ref4) {
  var justify = _ref4.justify;
  return justify;
});
export default function Section(_ref5) {
  var component = _ref5.component,
      children = _ref5.children,
      className = _ref5.className,
      direction = _ref5.direction,
      align = _ref5.align,
      justify = _ref5.justify,
      marginTop = _ref5.marginTop;
  return /*#__PURE__*/React.createElement(Wrapper, {
    as: component,
    className: className,
    align: align,
    justify: justify,
    direction: direction,
    marginTop: marginTop
  }, children);
}
Section.defaultProps = {
  component: 'section',
  direction: 'row',
  align: 'normal',
  justify: 'normal',
  marginTop: true
};